import { darken } from "@mui/material";
import { generateClasses } from "../../utilities/components/styles";
import { mergeWithComponentCustomizedStyles } from "conversional-theme";
var Styles = function (theme) {
    var textLinkColor = theme.colors.textLink || theme.colors.brand;
    return mergeWithComponentCustomizedStyles(theme, "markdownRenderer", {
        markdownLink: {
            color: textLinkColor,
            textDecoration: 'underline',
            fontSize: 'inherit',
            ":hover": {
                color: darken(textLinkColor, 0.2)
            }
        },
    });
};
export var getStyles = generateClasses(Styles);
